import { createContext } from 'react';

type StickyActionBarHeight = Readonly<{
	/**
	 * Height (in px, rounded) of the bottom of the viewport that the mobile sticky action bar
	 * covers. It is `0` when no sticky bar with a layout box is mounted (the mounted one is
	 * `display: none` at `md` and up), and when the bar is parked off-screen.
	 *
	 * Sections tracked by a bottom-of-viewport Waypoint should pass this as `bottomOffset`:
	 * IntersectionObserver has no concept of DOM occlusion, so without it a section can be
	 * geometrically "in view" while fully hidden behind the bar. See CHANGE-99504.
	 *
	 * While the bar's position is still unknown (before `AfterMobileActionButtonWaypoint` first
	 * reports), the value is the bar's full height. Its sole writer (`ActionButtonWrapper`) publishes
	 * in a layout effect, so the value is right on the first painted frame of a deep-linked or
	 * scroll-restored load, and a tracker never counts an impression against the un-offset viewport.
	 * If the bar turns out to be parked, the value drops to `0` and the tracker re-evaluates.
	 */
	height: number;
	setHeight: (height: number) => void;
}>;

export const StickyActionBarHeightContext = createContext<StickyActionBarHeight | undefined>(undefined);
